<script>
export default {
  name: 'CalendarEditIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#8E8E8E',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.7502 3.56V2C16.7502 1.59 16.4102 1.25 16.0002 1.25C15.5902 1.25 15.2502 1.59 15.2502 2V3.5H8.75023V2C8.75023 1.59 8.41023 1.25 8.00023 1.25C7.59023 1.25 7.25023 1.59 7.25023 2V3.56C4.55023 3.81 3.24023 5.42 3.04023 7.81C3.02023 8.1 3.26023 8.34 3.54023 8.34H20.4602C20.7502 8.34 20.9902 8.09 20.9602 7.81C20.7602 5.42 19.4502 3.81 16.7502 3.56Z"
      :fill="color"
    />
    <path
      d="M20 9.83984H4C3.45 9.83984 3 10.2898 3 10.8398V16.9998C3 19.9998 4.5 21.9998 8 21.9998H16C19.5 21.9998 21 19.9998 21 16.9998V10.8398C21 10.2898 20.55 9.83984 20 9.83984ZM14.84 14.9898L14.34 15.4998H14.33L11.3 18.5298C11.17 18.6598 10.9 18.7998 10.71 18.8198L9.36 19.0198C8.87 19.0898 8.53 18.7398 8.6 18.2598L8.79 16.8998C8.82 16.7098 8.95 16.4498 9.08 16.3098L12.12 13.2798L12.62 12.7698C12.95 12.4398 13.32 12.1998 13.72 12.1998C14.06 12.1998 14.43 12.3598 14.84 12.7698C15.74 13.6698 15.45 14.3798 14.84 14.9898Z"
      :fill="color"
    />
  </svg>
</template>
